import { render, staticRenderFns } from "./TextReplacer.vue?vue&type=template&id=f880428c&"
import script from "./TextReplacer.vue?vue&type=script&lang=js&"
export * from "./TextReplacer.vue?vue&type=script&lang=js&"
import style0 from "./TextReplacer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports